"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _PageLoadingTimeRadialData = _interopRequireDefault(require("./components/PageLoadingTimeRadialData"));

var _PageSizeRadialData = _interopRequireDefault(require("./components/PageSizeRadialData"));

var _PageRequestsRadialData = _interopRequireDefault(require("./components/PageRequestsRadialData"));

var _YesNoData = _interopRequireDefault(require("./components/YesNoData"));

var PERFORMANCE_KEY = 'performanceAudit';
var _default = {
  topResults: [new _PageSizeRadialData.default({
    localizedTextKey: 'results.performance.pageSize',
    resultKeyPath: [PERFORMANCE_KEY, 'pageSize'],
    progressBarIcon: 'icon-download'
  }), new _PageRequestsRadialData.default({
    localizedTextKey: 'results.performance.pageRequests',
    resultKeyPath: [PERFORMANCE_KEY, 'requestCount'],
    progressBarIcon: 'icon-cloud-refresh'
  }), new _PageLoadingTimeRadialData.default({
    localizedTextKey: 'results.performance.pageSpeed',
    resultKeyPath: [PERFORMANCE_KEY, 'loadTime'],
    progressBarIcon: 'icon-timer'
  })],
  middleResults: [new _YesNoData.default({
    localizedTextKey: 'results.performance.browserCaching',
    resultKeyPath: [PERFORMANCE_KEY, 'hasBrowserCaching'],
    resultGradeFlip: true
  }), new _YesNoData.default({
    localizedTextKey: 'results.performance.pageRedirects',
    resultKeyPath: [PERFORMANCE_KEY, 'hasNoRedirects']
  }), new _YesNoData.default({
    localizedTextKey: 'results.performance.imageSize',
    resultKeyPath: [PERFORMANCE_KEY, 'areImagesProperlySized']
  })],
  bottomResults: [new _YesNoData.default({
    localizedTextKey: 'results.performance.minifiedJs',
    resultKeyPath: [PERFORMANCE_KEY, 'isJsMinified']
  }), new _YesNoData.default({
    localizedTextKey: 'results.performance.minifiedCss',
    resultKeyPath: [PERFORMANCE_KEY, 'isCssMinified']
  })]
};
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/data/PerformanceData.js
// module id = 146
// module chunks = 0